import { render } from "./IconExternalLinkOutline.vue?vue&type=template&id=2ba4d384"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconExternalLinkOutline.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ba4d384"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ba4d384', __exports__)) {
    api.reload('2ba4d384', __exports__)
  }
  
  module.hot.accept("./IconExternalLinkOutline.vue?vue&type=template&id=2ba4d384", () => {
    api.rerender('2ba4d384', render)
  })

}


export default __exports__